import styled from 'styled-components';

const SubmitActionWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	margin: 12px 0 0;

	> button {
		width: 322px;
	}
`;

export default SubmitActionWrapper;
